import request from '@/utils/request';
const baseURL = process.env.VUE_APP_SORTING;

/**
 * 分页查询分拣称重记录
 * @param {Object} data - 查询参数
 * @param {number} data.pageNumber - 页码（从1开始）
 * @param {number} data.pageSize - 每页数量
 * @param {Object} data.params - 查询条件
 * @returns {Promise}
 */
export function getWeighingRecordPage(data) {
  return request({
    baseURL: baseURL,
    url: '/weighingRecord/page',
    method: 'post',
    data
  });
}
